import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-338a5dae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "el-dialog__body-title" }
const _hoisted_2 = { class: "order-num" }
const _hoisted_3 = { class: "el-dialog__body-footer flex-ter-end" }

import { t } from '@/plugins/i18n'
import { ref, watch, nextTick, computed } from 'vue'
import { userApplyCancel } from '@/apis/order'
import { ElMessage } from 'element-plus'
import ADialog from './ADialog.vue'
import OrderItemTable from '../OrderItemTable.vue'
import { canApplyCancel } from './data'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  rowItem: {
    type: Object,
    default: () => ({})
  },
  dataList: {
    type: Array,
    default: () => []
  }
},
  emits: ['update:visible', 'refresh'],
  setup(__props, { emit }) {

const props = __props




const tableConfig = {
  showSelection: true,
  showExpand: true,
  rowKey: 'platformOrderItemId',
  expandConfigId: 'combinationOrderItemList',
  selectable: (row: any) => canApplyCancel(row, props.rowItem)

}
watch(() => props.visible, (newValue) => {
  if (newValue) {
    toggleAll()
  }
})

const columns:any = [
  {
    label: t('商品信息'),
    prop: 'shoppingInfo',
    align: 'center',
    width: 230,
    slotName: 'shoppingInfo'
  },
  {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    align: 'center',
    slotName: 'productPropertiesName'
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    align: 'center',
    slotName: 'productSku'
  },
  {
    label: t('商品状态'),
    align: 'center',
    slotName: 'shoppingStats'
  },
  {
    label: t('下单数量'),
    prop: 'orderQuantity',
    align: 'center'
  },
  {
    label: t('取消数量'),
    align: 'center',
    slotName: 'cancel'
  }
]

const STableRef = ref()
const toggleAll = () => {
  nextTick(() => {
    STableRef.value && STableRef.value.toggleAll()
  })
}

const selectionList: any = ref([])
const handleSelection = (val: any[]) => {
  // 表格下单的待付款订单只能全选
  if (props.rowItem.orderSource === 6 && props.rowItem.platformOrderStatus === 2 && (props.dataList.length !== val.length)) {
    toggleAll()
  }
  selectionList.value = val
}

const close = () => {
  emit('update:visible', false)
  selectionList.value = []
}

const orderStatusList = computed(() => {
  let orderStatusList: any[] = []
  for (const t of (selectionList.value || [])) {
    if (t.orderItemStatus) {
      orderStatusList = orderStatusList.concat(t.orderItemStatus.split(',').map((v: string) => Number(v)))
    }
  }
  return [...new Set(orderStatusList)]
})

const cancelVisible = ref(false)
const openCancel = () => {
  if (!selectionList.value.length) return ElMessage.warning(t('请选择需要取消的商品'))
  cancelVisible.value = true
}

// oem 商品需要选择所有相同的oem后才能取消
const oemOpenCancel = () => {
  const oemList: any = []
  for (const t of props.dataList as any) {
    if (t.productType === 2) {
      const idx: number = oemList.findIndex((e: any) => e.productTitleJp === t.productTitleJp)
      if (idx !== -1) {
        oemList[idx].num++
      } else {
        oemList.push({
          productTitleJp: t.productTitleJp,
          num: 1
        })
      }
    }
  }
  for (const t of selectionList.value as any) {
    const idx: number = oemList.findIndex((e: any) => e.productTitleJp === t.productTitleJp)
    if (idx !== -1) {
      if (!--oemList[idx].num) {
        oemList[idx].flag = false
      } else {
        oemList[idx].flag = true
      }
    } else {
      continue
    }
  }
  return oemList.some((e: any) => e.flag)
}

const submit = () => {
  if (oemOpenCancel()) {
    cancelVisible.value = false
    close()
    emit('refresh')
    return
  }
  userApplyCancel({
    platformOrderNo: props.rowItem.platformOrderNo,
    shopProductSkus: selectionList.value.map((e: any) => e.shopProductSku),
    platformOrderItemIds: selectionList.value.map((e: any) => e.platformOrderItemId)
  }).then((res: any) => {
    if (res.success) {
      ElMessage.success(t('取消成功'))
      cancelVisible.value = false
      close()
      emit('refresh')
    }
  })
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      "model-value": __props.visible,
      "destroy-on-close": "",
      onClose: close
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('请确认取消信息')), 1),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('THE CKB订单编号')) + ": " + _toDisplayString(__props.rowItem.platformOrderNo), 1),
        _createElementVNode("div", null, [
          _createVNode(OrderItemTable, {
            ref: (_value, _refs) => {
              _refs['STableRef'] = _value
              STableRef.value = _value
            },
            dataList: __props.dataList,
            columns: columns,
            tableConfig: tableConfig,
            onSelectionChange: handleSelection
          }, null, 8, ["dataList"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, { onClick: close }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: openCancel
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('提交')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["model-value"]),
    _createVNode(ADialog, {
      visible: cancelVisible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((cancelVisible).value = $event)),
      "status-list": _unref(orderStatusList),
      platformOrderType: __props.rowItem.platformOrderType,
      onSubmit: submit
    }, null, 8, ["visible", "status-list", "platformOrderType"])
  ], 64))
}
}

})